__turbopack_context__.v({
  "buttons-container": "AnnouncementsList-module-scss-module__nfpClW__buttons-container",
  "columns_centered": "AnnouncementsList-module-scss-module__nfpClW__columns_centered",
  "columns_numeric": "AnnouncementsList-module-scss-module__nfpClW__columns_numeric",
  "fade-in-uboa5g8": "AnnouncementsList-module-scss-module__nfpClW__fade-in-uboa5g8",
  "header_spaced": "AnnouncementsList-module-scss-module__nfpClW__header_spaced",
  "report": "AnnouncementsList-module-scss-module__nfpClW__report",
  "toggle": "AnnouncementsList-module-scss-module__nfpClW__toggle",
  "toggle-border": "AnnouncementsList-module-scss-module__nfpClW__toggle-border",
  "toggle-button": "AnnouncementsList-module-scss-module__nfpClW__toggle-button",
  "toggle-button-selected": "AnnouncementsList-module-scss-module__nfpClW__toggle-button-selected",
  "water-account-list": "AnnouncementsList-module-scss-module__nfpClW__water-account-list",
  "water-account-list-header": "AnnouncementsList-module-scss-module__nfpClW__water-account-list-header",
  "wrapper": "AnnouncementsList-module-scss-module__nfpClW__wrapper",
});
